import { ColDef } from 'ag-grid-community';
import { useIntl } from 'react-intl';
import { RIGHT_ALIGNED } from 'common/constants';
import { tableHeaders } from './messages';
import { ApScheduleInvoice, ApScheduleVendor } from './types';

export const useApScheduleColumnDefs = (): {
  masterColDefs: ColDef<ApScheduleVendor>[];
  detailColDefs: ColDef<ApScheduleInvoice>[];
} => {
  const intl = useIntl();
  return {
    masterColDefs: [
      {
        field: 'vendorNo',
        cellRenderer: 'agGroupCellRenderer',
        headerName: intl.formatMessage(tableHeaders.vendorNo),
        maxWidth: 125
      },
      {
        field: 'vendorName',
        headerName: intl.formatMessage(tableHeaders.vendorName)
      },
      {
        field: 'paymentMethod',
        headerName: intl.formatMessage(tableHeaders.paymentMethod),
        maxWidth: 175
      },
      {
        field: 'amount',
        headerName: intl.formatMessage(tableHeaders.totalDue),
        type: RIGHT_ALIGNED
      },
      {
        field: 'discountAmount',
        headerName: intl.formatMessage(tableHeaders.discount),
        type: RIGHT_ALIGNED
      },
      {
        field: 'netAmount',
        headerName: intl.formatMessage(tableHeaders.netDue),
        type: RIGHT_ALIGNED
      }
    ],
    detailColDefs: [
      {
        field: 'invoiceNumber',
        headerName: intl.formatMessage(tableHeaders.invoiceNo)
      },
      {
        field: 'dueDate',
        headerName: intl.formatMessage(tableHeaders.dueDate)
      },
      {
        field: 'invoiceAmount',
        headerName: intl.formatMessage(tableHeaders.totalDue)
      },
      {
        field: 'discountAmount',
        headerName: intl.formatMessage(tableHeaders.discount)
      },
      {
        field: 'netAmount',
        headerName: intl.formatMessage(tableHeaders.netPayment)
      },
      { field: 'status', headerName: intl.formatMessage(tableHeaders.status) }
    ]
  };
};
